module.exports = __webpack_public_path__ + "static/media/INVALIDIMMUNIZATION.59809fa1.png";